import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { BookingData } from "../../types/view-booking";

interface Props {
  open: boolean;
  onClose: () => void;
  bookingData?: BookingData | null;
}

export default function ThankYouMessageModal({
  open,
  onClose,
  bookingData,
}: Props) {
  const clientName = bookingData?.organiser?.name || "Client";
  const phone = bookingData?.organiser?.phone || "";

  const [message, setMessage] = useState("");

  useEffect(() => {
    if (open) {
      setMessage(
        `Dear ${clientName},\n\nWe sincerely appreciate your trust in our services. Your unwavering support truly means the world to us and inspires us to strive for excellence every single day. It is customers like you who motivate us to push our boundaries and enhance our offerings.\n\nThank you for being such an essential part of our journey. We are genuinely excited about the opportunity to continue serving you with the highest level of dedication and care, and we look forward to exceeding your expectations in the future.`,
      );
    }
  }, [open, clientName]);

  const handleShareWhatsApp = () => {
    const encoded = encodeURIComponent(message);
    const phoneClean = phone.replace(/\D/g, "");
    window.open(`https://wa.me/${phoneClean}?text=${encoded}`, "_blank");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 4, maxWidth: 500, p: 1 } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 600,
          fontSize: 18,
          pb: 2,
        }}
      >
        Client Thank you message
      </DialogTitle>

      <DialogContent sx={{ pt: 1, pb: 2 }}>
        <TextField
          fullWidth
          multiline
          minRows={8}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": {
              borderRadius: 3,
              bgcolor: "#f4f6f8",
              fontSize: 13,
              lineHeight: 1.6,
              color: "#334155",
              "& fieldset": { border: "none" },
            },
          }}
        />

        <Button
          variant="contained"
          fullWidth
          onClick={handleShareWhatsApp}
          startIcon={<WhatsApp />}
          sx={{
            bgcolor: "#25D366",
            color: "white",
            textTransform: "none",
            borderRadius: 2,
            py: 1.2,
            fontSize: 14,
            fontWeight: 500,
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#20bd5a",
              boxShadow: "none",
            },
          }}
        >
          Share via whatsapp
        </Button>
      </DialogContent>
    </Dialog>
  );
}
